export default __webpack_public_path__ + "static/media/logo-light.2ca7ad17.png";